import type { Styling } from 'src/context/styling';
import { davidLloydBuildDomains, getBuildDomainForBuildType } from 'src/enums/build/build-domain';
import type { BuildType } from 'src/enums/build/build-type';
import {
  ButtonStyle,
  RedesignButtonStyle,
  RedesignHarbourButtonStyle,
  RedesignMeridianButtonStyle,
} from 'src/enums/button-style';

import type { GeneralRedesignButtonStyle } from '../../../cms/common-widgets/button-widget';

export const getButtonCss = (
  buttonStyle: Queries.ButtonStyle | null | undefined,
  styling: Styling
) => {
  switch (buttonStyle) {
    case ButtonStyle.PRIMARY:
      return styling.buttons.primary;
    case ButtonStyle.SECONDARY:
      return styling.buttons.secondary;
    case ButtonStyle.TRANSPARENT:
      return styling.buttons.transparent;
    case ButtonStyle.SECONDARY_TRANSPARENT:
      return styling.buttons.secondaryTransparent;
    case ButtonStyle.ALERT:
      return styling.buttons.alert;
    default:
      return undefined;
  }
};

export const getNewButtonCss = (
  buttonStyle: GeneralRedesignButtonStyle | undefined,
  styling: Styling
) => {
  switch (buttonStyle) {
    case RedesignButtonStyle.PLUM:
      return styling.redesignButtons.plum;
    case RedesignButtonStyle.TRANSPARENT_WITH_PLUM_FONT:
      return styling.redesignButtons.transparent;
    case RedesignButtonStyle.TRANSPARENT_WITH_WHITE_FONT:
      return styling.redesignButtons.transparentWithWhiteFont;
    case RedesignButtonStyle.DARK_GREEN:
      return styling.redesignButtons.darkGreen;
    case RedesignButtonStyle.WHITE_WITH_GREEN_FONT:
      return styling.redesignButtons.whiteWithGreenFont;
    case RedesignButtonStyle.WHITE_WITH_PLUM_FONT:
      return styling.redesignButtons.whiteWithPlumFont;
    case RedesignMeridianButtonStyle.ORANGE:
      return styling.redesignButtons.orange;
    case RedesignMeridianButtonStyle.BLUE:
      return styling.redesignButtons.blue;
    case RedesignMeridianButtonStyle.TRANSPARENT_WITH_WHITE_FONT_AND_BORDER:
      return styling.redesignButtons.transparentWithWhiteFontAndBorder;
    case RedesignMeridianButtonStyle.TRANSPARENT_WITH_BLUE_FONT_AND_BORDER:
      return styling.redesignButtons.transparentWithBlueFontAndBorder;
    case RedesignMeridianButtonStyle.WITHOUT_BORDERS_WITH_WHITE_FONT:
      return styling.redesignButtons.withoutBordersWithWhiteFont;
    case RedesignMeridianButtonStyle.WITHOUT_BORDERS_WITH_BLUE_FONT:
      return styling.redesignButtons.withoutBordersWithBlueFont;
    case RedesignHarbourButtonStyle.HARBOUR_GREY_WITH_WHITE_FONT:
      return styling.redesignButtons.harbourGreyWithWhiteFont;
    case RedesignHarbourButtonStyle.TRANSPARENT_WITH_GREY_FONT_AND_BORDER:
      return styling.redesignButtons.transparentWithGreyFontAndBorder;
    case RedesignHarbourButtonStyle.TRANSPARENT_WITH_GOLD_FONT_AND_BORDER:
      return styling.redesignButtons.transparentWithGoldFontAndBorder;
    case RedesignHarbourButtonStyle.WHITE_WITH_HARBOUR_GREY_FONT:
      return styling.redesignButtons.whiteWithHarbourGreyFont;
    default:
      return undefined;
  }
};

export const getBuildButtonCss = (
  buttonStyle: RedesignButtonStyle | Queries.ButtonStyle | null | undefined,
  styling: Styling,
  buildType: BuildType
) =>
  davidLloydBuildDomains.includes(getBuildDomainForBuildType(buildType))
    ? getNewButtonCss(buttonStyle as RedesignButtonStyle, styling)
    : getButtonCss(buttonStyle, styling);
